import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sliceKey as name } from './utils';
import { InstoreCategory, InstoreState, SelectedStoreData, Store } from './types';
import {
	getNetworkState,
	NetworkError,
	networkInitialState,
	NetworkStatuses,
} from '../../store/network';

const initialState: InstoreState = {
	stores: [],
	storesNetwork: networkInitialState,
	categories: [],
	categoriesNetwork: networkInitialState,
	selectedStoreCode: null,
	selectedStoreData: null,
};

const InstoreSlice = createSlice({
	name,
	initialState,
	reducers: {
		setSelectedStoreData(state, action: PayloadAction<{ data: SelectedStoreData }>) {
			const { data } = action.payload;
			state.selectedStoreData = data;
		},
		setSelectedStoreCode(state, action: PayloadAction<{ storeCode: number }>) {
			const { storeCode } = action.payload;
			state.selectedStoreCode = storeCode;
		},
		fetchCategoriesRequest(state) {
			state.categoriesNetwork = getNetworkState(NetworkStatuses.REQUEST);
		},
		fetchCategoriesSuccess(state, action: PayloadAction<{ data: InstoreCategory[] }>) {
			const { data } = action.payload;
			state.categories = data;
			state.categoriesNetwork = getNetworkState(NetworkStatuses.SUCCESS);
		},
		fetchCategoriesFailed(state, action: PayloadAction<{ error: NetworkError }>) {
			const { error } = action.payload;
			state.categoriesNetwork = getNetworkState(NetworkStatuses.FAILED, error);
		},
		fetchStoresRequest(state) {
			state.storesNetwork = getNetworkState(NetworkStatuses.REQUEST);
		},
		fetchStoresSuccess(state, action: PayloadAction<{ data: Store[] }>) {
			const { data } = action.payload;
			state.stores = data;
			state.storesNetwork = getNetworkState(NetworkStatuses.SUCCESS);
		},
		fetchStoresFailed(state, action: PayloadAction<{ error: NetworkError }>) {
			const { error } = action.payload;
			state.storesNetwork = getNetworkState(NetworkStatuses.FAILED, error);
		},
	},
});

export const { actions: instoreActions, reducer: instoreReducer, name: instoreName } = InstoreSlice;

export const InstoreInitialState = initialState;
